import { faBell } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CloseButton from 'Components/modals/CloseButton';
import { Box, Heading, Layer, Text } from 'grommet';

import style from './style.scss';

const ActionModal = ({ img, title, subTitle, onClose, primaryButton, secondaryButton }) => (
  <Layer className={style.layer} onEsc={onClose} onClickOutside={onClose}>
    <div className={style.container}>
      {img && (
        <div className={style.header}>
          {img}
          <CloseButton varient="grey" onClick={onClose} className={style.closeBtn} />
        </div>
      )}
      <Box className={style.contentWrapper}>
        <Heading level="3" textAlign="center" className={style.headingText}>
          <FontAwesomeIcon icon={faBell} className={style.bellIcon} />
          {title}
        </Heading>
        <Text size="large" textAlign="center" className={style.description}>
          {subTitle}
        </Text>
      </Box>
      <Box pad="25px" align="center">
        <div className={style.buttonsContainer}>
          <div>{primaryButton}</div>
          <div>{secondaryButton}</div>
        </div>
      </Box>
    </div>
  </Layer>
);

export default ActionModal;
